import styled from 'styled-components';
import { Digits as DigitsComponent } from '~/components';

export const Title = styled.h1`
  font-size: 1.625rem;
  font-weight: bold;
  margin-bottom: ${({ marginBottom }) => marginBottom};
  text-align: center;
`;
export const Digits = styled(DigitsComponent)`
  margin-bottom: 44px;
`;
export const Description = styled.p`
  font-size: 0.9375rem;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  line-height: 36px;
`;
